import { render, staticRenderFns } from "./eco-rating.vue?vue&type=template&id=d9839d5e"
import script from "./eco-rating.vue?vue&type=script&lang=ts"
export * from "./eco-rating.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./eco-rating.scss?vue&type=style&index=0&prod&lang=scss&external")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports